import { Controller } from "@hotwired/stimulus"
import * as Log from "web-ui/log"

export default class extends Controller {
  connect() {
    this.debug("Connect")

    this.element.addEventListener("change", this.change)
  }

  change = () => {
    this.debug("Submit")
    this.element.requestSubmit()
  }

  disconnect() {
    this.debug("Disconnect")

    this.element.removeEventListener("change", this.change)
  }

  debug(message, data) {
    Log.debug("Passive Submission Form - " + message, data)
  }
}
